import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgCombineChecks = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 15.623 12 14.046l-2.5 1.577L7 14.046l-2.5 1.577V4.403c0-.372.15-.73.418-.992C5.186 3.148 5.55 3 5.928 3h7.143c.38 0 .743.148 1.01.41.269.264.419.62.419.993V12m0 3.623V12m0 3.623H17M9.5 9.78V21l2.5-1.578L14.5 21l2.5-1.578L19.5 21V9.78c0-.373-.15-.73-.418-.993a1.442 1.442 0 0 0-1.01-.41h-7.143c-.38 0-.743.147-1.01.41a1.39 1.39 0 0 0-.419.992Zm0 0H7M14.5 12H17M7 6h5",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

export { SvgCombineChecks as default };
